import React from "react";
import {
  Button,
  ButtonGroup,
  Chip,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { PlusOutlined } from "@ant-design/icons";
import StyledButton from "./StyledButton";
import { CheckValue } from "../../Service/service";
import { CardIcon, ListIcon } from "../Icon";
import { useListContextContext } from "../../container/Internal/Campuses/Context";
import StyleStack from "./StyleStack";
import { Filter } from "../../container/Internal/Campuses/Filter";
import { SearchInput } from "../FormInput";
import { useTabFilter } from "../../context";

const PageTitle = (props) => {
  const {
    title,
    count = null,
    isFilter = false,
    isAction = false,
    isWrap = false,
    isUIFilter = false,
    isTabFilter = false,
    defaultFilter = [],
    searchPlaceHolder = null,
    addButtonText = null,
    addButtonClick = null,
  } = props;

  const isAddButtonShow =
    CheckValue(addButtonClick) && CheckValue(addButtonText);
  return (
    <Stack
      direction={"row"}
      spacing={0.2}
      gap={1.5}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: isWrap ? "wrap" : "nowrap",
      }}
    >
      <Typography variant="h1" sx={{ flexGrow: 1 }}>
        {title}
        {count ? (
          <Chip
            label={count}
            sx={{ marginLeft: 2, height: 28, [`& .MuiChip-label`]: {} }}
          />
        ) : null}
      </Typography>
      <Stack
        direction={"row"}
        justifyContent={'flex-end'}
        spacing={0.2}
        sx={{ width: isWrap ? "100%" : "inherit", flexGrow: 1 }}
      >
        {isAction ? (
          <Stack direction={"row"} gap={1.5} sx={{ flexGrow: 1 }}>
            {searchPlaceHolder ? (
              <SearchInput placeHolder={searchPlaceHolder} />
            ) : null}
            {isFilter ? <Filter defaultFilter={defaultFilter} /> : null}
            {isUIFilter ? <UIFilter /> : null}
            {isTabFilter ? <TabFilter /> : null}
          </Stack>
        ) : null}
        {isAddButtonShow ? (
          <StyledButton
            variant="contained"
            startIcon={<PlusOutlined />}
            onClick={addButtonClick}
          >
            {addButtonText}
          </StyledButton>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default React.memo(PageTitle);

const TabFilter = React.memo(() => {
  const { tabArr, setTab, tabValue } = useTabFilter();
  return (
    <ButtonGroup variant="outlined" aria-label="Basic button group">
      {tabArr.map((el) => (
        <ButtonUI
          value={el.value}
          selected={el.value === tabValue}
          onClick={setTab(el.value)}
          text={el.text}
          key={el.value}
        />
      ))}
    </ButtonGroup>
  );
});
const UIFilter = React.memo(() => {
  const { isList, setIsList } = useListContextContext();

  return (
    <StyleStack
      direction={"row"}
      sx={{
        padding: 0.5,
        gap: 1,
        height: 44,
      }}
    >
      <IconButtonUI
        value={!isList}
        onClick={() => setIsList(false)}
        Icon={CardIcon}
      />
      <IconButtonUI
        value={isList}
        onClick={() => setIsList(true)}
        Icon={ListIcon}
      />
    </StyleStack>
  );
});

const IconButtonUI = React.memo((props) => {
  const { value, Icon, onClick } = props;
  return (
    <IconButton
      aria-selected={value}
      onClick={onClick}
      sx={{
        background: value ? "#101828" : "inherit",
        borderRadius: 1,
        [`&:hover`]: {
          background: value ? "#101828" : "revert",
        },
      }}
    >
      <Icon sx={{ color: value ? "#FFFFFF" : "#6C6C6C" }} />
    </IconButton>
  );
});
const ButtonUI = React.memo((props) => {
  const { value, text, onClick, selected } = props;
  return (
    <Button
      // aria-selected={selected}
      variant={selected ? "contained" : "outlined"}
      onClick={onClick}
    >
      {text}
    </Button>
  );
});
